import { FILTERS } from '~/const';
import useContentAvailability from '~/hooks/useContentAvailability';
import { HITS_TYPES } from '~/pages/const';

const useAvailableContentTypesFilter = () => {
  const contentAvailability = useContentAvailability();

  const contentTypeFilter = [
    contentAvailability.pathways && `${FILTERS.SearchType}:${HITS_TYPES.PATHWAY}`,
    `${FILTERS.SearchType}:${HITS_TYPES.VIDEO}`,
    contentAvailability.insights && `${FILTERS.SearchType}:${HITS_TYPES.NEWS}`,
    contentAvailability.glossary && `${FILTERS.SearchType}:${HITS_TYPES.GLOSSARY}`,
    contentAvailability.courses && `${FILTERS.SearchType}:${HITS_TYPES.COURSE}`,
  ]
    .filter(Boolean)
    .join(' OR ');

  return contentTypeFilter;
};

export default useAvailableContentTypesFilter;
